document.addEventListener("DOMContentLoaded", function(event) {
  let carouselContainer = document.querySelector('.product-gallery .product-gallery__carousel');
  if (carouselContainer !== null) {
    let carouselContainerHeight = carouselContainer.clientHeight - 24;
    document.querySelector('.product-gallery .product-gallery__thumbnail-list carousel-navigation').style.maxHeight = carouselContainerHeight + 'px';
    document.querySelector('.product-gallery .product-gallery__thumbnail-list').style.opacity = '1';
  }

  function getNextSiblingBlock(element) {
  while ((element = element.nextSibling)) {
      if (element.style.display === '' && !element.hasAttribute('hidden')) {
        return element;
      }
    }
    return null;
  }

  const thumbnailMobileControlNext = document.getElementById('thumbnail-control-next');
  if (thumbnailMobileControlNext !== null) {
    thumbnailMobileControlNext.addEventListener('click', function() {
      const element = document.querySelector('carousel-navigation button[aria-current="true"]');
      const nextSibling = getNextSiblingBlock(element);
      
      if (nextSibling) {
        let mediaId = nextSibling.getAttribute('aria-label');
        if (mediaId !== null) {
          document.querySelector('button[aria-label="'+ mediaId +'"]').click();
        }
      }
    });
  }
});

window.addEventListener('resize', function() {
  let carouselContainer = document.querySelector('.product-gallery .product-gallery__carousel');
  if (carouselContainer !== null) {
    let carouselContainerHeight = carouselContainer.clientHeight - 24;
    document.querySelector('.product-gallery .product-gallery__thumbnail-list carousel-navigation').style.maxHeight = carouselContainerHeight + 'px';
  }
});